import cx from 'classnames';
import styles from './TriStateProgressBar.scss';
import _ from 'lodash';

const calculateBarPercentage = (value, total) =>
  Math.floor((value / total) * 100);
/* eslint-disable react/prop-types */ // TODO: add props

const ProgressIndicator = ({
  value,
  total,
  className,
  tooltipText,
  showValue = false,
}) => {
  const progress = calculateBarPercentage(value, total);

  return (
    <span
      className={cx(styles.progressIndicator, className, {
        [styles.growToFillPixelGaps]: progress > 0,
      })}
      style={{ width: `${progress}%` }}
      title={tooltipText}
    >
      {showValue && value ? value : null}
    </span>
  );
};

const ZeroProgressBar = ({ className }) => (
  <span className={cx(styles.progressBar, className)} />
);

const validateAndSum = (...values) => {
  const isValid = _.every(values, (value) => !isNaN(value) && value >= 0);
  const total = isValid ? _.sum(values) : 0;
  return { isValid, total };
};

const TriStateProgressBar = ({
  nullCount,
  positiveCount,
  negativeCount,
  nullCountClassName,
  positiveCountClassName,
  negativeCountClassName,
  order = ['null', 'positive', 'negative'],
  className,
  nullCountTooltipText,
  positiveCountTooltipText,
  negativeCountTooltipText,
  showNullCountValue = false,
  showPositiveCountValue = false,
  showNegativeCountValue = false,
}) => {
  const { isValid, total } = validateAndSum(
    nullCount,
    positiveCount,
    negativeCount
  );
  if (!isValid || total <= 0) {
    return <ZeroProgressBar />;
  }

  const segments = {
    null: (
      <ProgressIndicator
        key="null"
        value={nullCount}
        total={total}
        className={cx(styles.nullCountProgressIndicator, nullCountClassName)}
        tooltipText={nullCountTooltipText}
        showValue={showNullCountValue}
      />
    ),
    positive: (
      <ProgressIndicator
        key="positive"
        value={positiveCount}
        total={total}
        className={cx(
          styles.positiveCountProgressIndicator,
          positiveCountClassName
        )}
        tooltipText={positiveCountTooltipText}
        showValue={showPositiveCountValue}
      />
    ),
    negative: (
      <ProgressIndicator
        key="negative"
        value={negativeCount}
        total={total}
        className={cx(
          styles.negativeCountProgressIndicator,
          negativeCountClassName
        )}
        tooltipText={negativeCountTooltipText}
        showValue={showNegativeCountValue}
      />
    ),
  };

  return (
    <span className={cx(styles.progressBar, className)}>
      {order.map((segment) => segments[segment])}
    </span>
  );
};

export default TriStateProgressBar;
